import React from "react";

const Printable = ({ amount }) => {
  return (
    <div className="card-body">
      <div style={{ fontSize: "0.7rem" }}>
        <ol>
          <li className="text-danger">
            Registration charges Rs {amount || process.env.REACT_APP_VISITOR_REGISTRATION_AMOUNT || 1180}/- including GST (which includes Entry charges & Lunch for 2 Days).
          </li>
          <li className="text-danger">
            Your registration is subject to approval by the team of KCE 26.
          </li>
          <li className="text-danger">
            Your amount will be refunded in the original payment mode if not approved.
          </li>
          <li className="text-danger">
            Your payment does not confirm your registration.
          </li>
          <li className="text-danger">
            No Refund is allowed under any circumstance’s in case you are unable to visit the expo.
          </li>
          <li className="text-danger">
            A waiting time of 5-10’minutes is expected for us to handover your Badges for entry. Kindly co-operate. 
          </li>
          <li className="text-danger">Rights of registration reserved.</li>
        </ol>
      </div>
      {/* <div className="checkmark-container">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="120"
                  height="120"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="green"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="bi bi-check-circle"
                >
                  <circle cx="12" cy="12" r="10" />
                  <path d="M9 12l2 2 4-4" />
                </svg>
              </div> */}
    </div>
  );
};

export default Printable;
